import React, { useEffect, useRef } from 'react'
import { ROUTES } from 'constants/Route.constants'
import { useMyOrgId, useWhoAmI } from 'queries/Auth.queries'
import { useNavigate } from 'react-router-dom'
import { FullPageLoader } from 'components/Loaders'
import { useQueryParams } from 'hooks/UseQueryParams'
import { QueryParamsEnum } from 'types/QueryParams.types'
import { StringParam } from 'serialize-query-params'

import { useRedirectToOrgAndChannel } from 'features/session-manager/Jobs/UseChannelRedirectJob'

export default function DefaultRedirect() {
  const navigate = useNavigate()
  const [params] = useQueryParams({ [QueryParamsEnum.REDIRECT_TO_CHANNEL]: StringParam })
  const envy = useMyOrgId()
  const whoami = useWhoAmI()
  const isRedirectingToChannel = useRef(false)
  const redirectToChannel = params[QueryParamsEnum.REDIRECT_TO_CHANNEL]
  const handleRedirect = useRedirectToOrgAndChannel()

  function goToSignInView() {
    navigate(ROUTES.SIGN_IN, { replace: true })
  }

  // we need to handle channel redirects for newly opened tabs triggered
  // by a user clicking a desktop notification and opening a new window
  useEffect(() => {
    if (whoami.isError) {
      goToSignInView()
      return
    }

    if (isRedirectingToChannel.current || !whoami.dataUpdatedAt) {
      return
    }

    if (redirectToChannel) {
      isRedirectingToChannel.current = true
      void handleRedirect(redirectToChannel)
      return
    }

    if (envy) {
      navigate(ROUTES.WORKSPACE_EXTERNAL_CHANNELS(envy), { replace: true })
      return
    }

    goToSignInView()
  }, [redirectToChannel, whoami.dataUpdatedAt, whoami.isError])

  return <FullPageLoader data-testid="channel-redirect-loader" />
}
